document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initHeroCarrusel();
  initGaleriaProducto();
  initVariantesProducto();
  initStickyComprar();
  initVideosAuto();
});

// Videos que se reproducen solos, sin sonido y en bucle (como un GIF).
// Se reproducen al entrar en pantalla y se pausan al salir para ahorrar datos.
function initVideosAuto() {
  var videos = document.querySelectorAll('video.mt-autovideo');
  if (!videos.length) return;
  function intentar(v) {
    v.muted = true; v.loop = true; v.playsInline = true; v.controls = false;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) intentar(e.target); else e.target.pause();
    });
  }, { threshold: 0.25 }) : null;
  videos.forEach(function (v) {
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('loop', '');
    if (io) io.observe(v); else intentar(v);
    v.addEventListener('loadeddata', function () { intentar(v); });
  });
  // Algunos celulares bloquean el inicio automático hasta el primer toque.
  var reintento = function () { videos.forEach(function (v) { if (v.paused) intentar(v); }); };
  ['touchstart', 'click', 'scroll'].forEach(function (ev) {
    window.addEventListener(ev, reintento, { once: true, passive: true });
  });
}

// Revela elementos .mt-reveal / .mt-reveal-stagger al entrar en pantalla.
function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

// Cifras animadas: cuenta de 0 al valor de data-hasta al entrar en pantalla.
function initContadores() {
  var els = document.querySelectorAll('.mt-count[data-hasta]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      obs.unobserve(el);
      var fin = parseFloat(el.getAttribute('data-hasta')) || 0;
      var dur = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var prog = Math.min((ts - inicio) / dur, 1);
        var actual = fin * (1 - Math.pow(1 - prog, 3));
        el.textContent = (fin % 1 === 0) ? Math.round(actual) : actual.toFixed(1);
        if (prog < 1) requestAnimationFrame(paso);
        else el.textContent = fin % 1 === 0 ? fin : fin.toFixed(1);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { obs.observe(el); });
}

// Carrusel del hero: cambia de slide automáticamente y con los puntos.
function initHeroCarrusel() {
  document.querySelectorAll('[data-mt-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('.mt-hero__slide');
    var dots = hero.querySelectorAll('.mt-hero__dot');
    if (slides.length < 2) return;
    var actual = 0;
    var intervalo = (parseInt(hero.getAttribute('data-intervalo'), 10) || 6) * 1000;
    function mostrar(i) {
      slides[actual].classList.remove('mt-hero__slide--activo');
      if (dots[actual]) dots[actual].classList.remove('mt-hero__dot--activo');
      actual = (i + slides.length) % slides.length;
      slides[actual].classList.add('mt-hero__slide--activo');
      if (dots[actual]) dots[actual].classList.add('mt-hero__dot--activo');
    }
    var timer = setInterval(function () { mostrar(actual + 1); }, intervalo);
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        clearInterval(timer);
        mostrar(i);
        timer = setInterval(function () { mostrar(actual + 1); }, intervalo);
      });
    });
  });
}

// Galería de producto: clic en miniatura cambia la imagen principal.
function initGaleriaProducto() {
  document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
    if (!principal || !minis.length) return;
    var lista = Array.prototype.slice.call(minis);
    var marco = principal.parentElement;
    var actual = 0;
    var contador = document.createElement('span');
    contador.className = 'mt-galeria__contador';
    contador.setAttribute('aria-live', 'polite');
    if (lista.length > 1) marco.appendChild(contador);

    function mostrar(i) {
      if (i < 0 || i >= lista.length) return;
      var mini = lista[i];
      var src = mini.getAttribute('data-src');
      var srcset = mini.getAttribute('data-srcset');
      if (!src) return;
      actual = i;
      principal.src = src;
      if (srcset) principal.srcset = srcset;
      lista.forEach(function (m) { m.classList.remove('mt-galeria__mini--activo'); });
      mini.classList.add('mt-galeria__mini--activo');
      contador.textContent = (i + 1) + ' / ' + lista.length;
      if (mini.scrollIntoView) {
        try { mini.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' }); } catch (e) {}
      }
    }
    lista.forEach(function (mini, i) { mini.addEventListener('click', function () { mostrar(i); }); });
    contador.textContent = '1 / ' + lista.length;

    // Flechas izquierda / derecha para indicar que se puede deslizar.
    if (lista.length > 1) {
      [['prev', 'Foto anterior', 'M15 5l-7 7 7 7', -1], ['sig', 'Foto siguiente', 'M9 5l7 7-7 7', 1]].forEach(function (d) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mt-galeria__flecha mt-galeria__flecha--' + d[0];
        b.setAttribute('aria-label', d[1]);
        b.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d[2] + '"/></svg>';
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          mostrar((actual + d[3] + lista.length) % lista.length);
        });
        marco.appendChild(b);
      });
    }

    // Deslizar con el dedo: izquierda = siguiente, derecha = anterior.
    var x0 = null, y0 = null, arrastre = false;
    marco.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; arrastre = false;
    }, { passive: true });
    marco.addEventListener('touchmove', function (e) {
      if (x0 === null) return;
      var dx = e.touches[0].clientX - x0, dy = e.touches[0].clientY - y0;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) arrastre = true;
    }, { passive: true });
    marco.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      mostrar(dx < 0 ? (actual + 1) % lista.length : (actual - 1 + lista.length) % lista.length);
    }, { passive: true });
  });
}

// Selector de variantes: localiza la variante y actualiza precio/id/disponibilidad.
function initVariantesProducto() {
  document.querySelectorAll('[data-mt-producto]').forEach(function (root) {
    var dataEl = root.querySelector('[data-mt-variantes-json]');
    var form = root.querySelector('[data-mt-form]');
    if (!dataEl || !form) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = root.querySelectorAll('[data-mt-opcion]');
    var inputId = form.querySelector('[name="id"]');
    var contenedor = root.parentElement || root;
    var precioEl = root.querySelector('[data-mt-precio]');
    var precioCompareEl = root.querySelector('[data-mt-precio-compare]');
    var precioStickyEl = contenedor.querySelector('[data-mt-precio-sticky]');
    var botonEl = root.querySelector('[data-mt-boton-comprar]');
    var botonStickyEl = contenedor.querySelector('[data-mt-sticky-comprar]');
    var textoAgotado = root.getAttribute('data-texto-agotado') || 'Agotado';
    var textoComprar = root.getAttribute('data-texto-comprar') || 'Añadir al carrito';

    function moneda(centavos) {
      return '$ ' + (centavos / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' MXN';
    }
    function actualizar() {
      var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === valores[i]; });
      });
      if (!variante) return;
      inputId.value = variante.id;
      if (precioEl) precioEl.textContent = moneda(variante.price);
      if (precioCompareEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioCompareEl.textContent = moneda(variante.compare_at_price);
          precioCompareEl.style.display = '';
        } else {
          precioCompareEl.style.display = 'none';
        }
      }
      if (precioStickyEl) precioStickyEl.textContent = moneda(variante.price);
      if (botonEl) {
        botonEl.disabled = !variante.available;
        botonEl.textContent = variante.available ? textoComprar : textoAgotado;
      }
      if (botonStickyEl) {
        botonStickyEl.disabled = !variante.available;
        botonStickyEl.textContent = variante.available ? textoComprar : textoAgotado;
      }
    }
    if (botonStickyEl && botonEl) {
      botonStickyEl.addEventListener('click', function () { botonEl.click(); });
    }
    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}

// Muestra la barra fija de compra en móvil solo cuando el botón real de compra sale de pantalla.
function initStickyComprar() {
  document.querySelectorAll('[data-mt-producto]').forEach(function (root) {
    var sticky = root.parentElement ? root.parentElement.querySelector('[data-mt-sticky]') : null;
    var botonReal = root.querySelector('[data-mt-boton-comprar]');
    if (!sticky || !botonReal || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('mt-producto__sticky--visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(botonReal);
  });
}

// Releasit COD Form: los botones "Ordenar ahora" de la tienda abren el formulario de pago contra entrega de Releasit.
// El botón rojo de Releasit queda oculto y este script le pasa el clic.
(function () {
  function botonReleasit() { return document.getElementById('_rsi-buy-now-button') || document.querySelector('div._rsi-buy-now-button, button._rsi-buy-now-button, a._rsi-buy-now-button'); }
  document.addEventListener('click', function (e) {
    var objetivo = e.target.closest ? e.target.closest('[data-mt-boton-comprar], .mt-oferta__boton') : null;
    if (!objetivo) return;
    var rsi = botonReleasit();
    if (!rsi) return;
    e.preventDefault();
    e.stopPropagation();
    rsi.click();
  }, true);
})();

// "Reseñas" del menú: lleva a la parte de abajo de la página de Inicio, donde está el bloque de reseñas de Trustoo.
(function () {
  var HASH = '#opiniones';
  function irAOpiniones() {
    if (location.hash !== HASH) return;
    var intentos = 0;
    function buscar() {
      var destino = document.getElementById('opiniones') || document.querySelector('#trustoo-widget-wrapper, [id*="trustoo"], [class*="trustoo-widget"]');
      if (!destino) {
        var secciones = document.querySelectorAll('main .shopify-section');
        destino = secciones.length ? secciones[secciones.length - 1] : null;
      }
      if (destino && (destino.getBoundingClientRect().height > 40 || intentos > 20)) {
        var y = destino.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: y, behavior: 'smooth' });
        return;
      }
      if (intentos++ < 40) setTimeout(buscar, 250);
    }
    buscar();
  }
  window.addEventListener('load', function () { setTimeout(irAOpiniones, 300); });
  window.addEventListener('hashchange', irAOpiniones);
})();
